// extracted by mini-css-extract-plugin
export default {"property1default":"Cta2_property1default__7x2Rm","vectorIcon":"Cta2_vectorIcon__ESOFA","loginWithGoogle":"Cta2_loginWithGoogle__FUJ72","iconplus":"Cta2_iconplus__GUOG1"};